
import React from 'react';

const CinemaDivider: React.FC = () => {
  return (
    <div className="relative w-full overflow-hidden my-12 group select-none pointer-events-none">
      {/* Central Glow / Scan Effect */}
      <div className="absolute inset-0 z-10 pointer-events-none flex justify-center">
        {/* The Light Beam */}
        <div className="h-full w-24 bg-gradient-to-r from-transparent via-prestige-gold/20 to-transparent blur-xl animate-pulse" />
        {/* The Sharp Focus Point */}
        <div className="absolute h-full w-[1px] bg-prestige-gold/40 shadow-[0_0_15px_rgba(245,158,11,0.5)]" />
      </div>

      {/* Scrolling Film Strip Container */}
      <div className="relative flex items-center h-20 sm:h-24">
        {/* Double Strip for Seamless Loop */}
        <div className="flex animate-scroll whitespace-nowrap">
          <StripSet />
          <StripSet />
        </div>
      </div>

      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        @media (max-width: 640px) {
          .animate-scroll {
            animation-duration: 20s;
          }
        }
      `}</style>
    </div>
  );
};

const StripSet: React.FC = () => {
  // We repeat frames to ensure the strip covers the screen and loops
  const frameCount = 10;
  return (
    <div className="flex items-center">
      {Array.from({ length: frameCount }).map((_, i) => (
        <div key={i} className="relative flex-shrink-0 w-32 sm:w-48 lg:w-56 h-full px-2 sm:px-3">
          {/* Top Sprocket Holes */}
          <div className="absolute top-0 left-0 right-0 flex justify-around px-1 py-1 sm:py-1.5">
            <Sprockets />
          </div>

          {/* Cinematic Frame */}
          <div className="w-full h-full border-[1.5px] border-zinc-300/10 dark:border-zinc-800 rounded-sm bg-midnight/40 flex items-center justify-center overflow-hidden">
             {/* Subtle internal texture for "Empty Frame" look */}
             <div className="w-full h-full bg-[radial-gradient(circle_at_center,_rgba(245,158,11,0.03)_0%,_transparent_70%)]" />
          </div>

          {/* Bottom Sprocket Holes */}
          <div className="absolute bottom-0 left-0 right-0 flex justify-around px-1 py-1 sm:py-1.5">
            <Sprockets />
          </div>
        </div>
      ))}
    </div>
  );
};

const Sprockets: React.FC = () => (
  <>
    {Array.from({ length: 4 }).map((_, j) => (
      <div key={j} className="w-2 h-2 sm:w-3 sm:h-3 bg-midnight border border-zinc-300/5 dark:border-zinc-800 rounded-[1px] shadow-inner" />
    ))}
  </>
);

export default CinemaDivider;
